import PageProps from '../_types/page-props.interface'
import ComingSoon from '../components/comingsoon'
import useDocumentTitle from '../hooks/useDocumentTitle'

export default function VideosPage (props: PageProps) {
  useDocumentTitle(props.title)

  return <ComingSoon />
}
